import { type FC } from 'react'

import { Modal } from '@/components/elements'
import { MENU } from '@/constants/common/message.constants'
import { type CustomerEntity, type SiteExEntity } from '@/libs/api'

import { type UpdateSiteRequest } from '../../api'
import { type CreateSiteDto } from '../../models'

import { SiteModalContent } from './SiteModalContent'

type Props = {
  open: boolean
  tenantKey: string
  dcId?: number
  updateRequest: UpdateSiteRequest | null
  /** 荷主関連付け欄の表示制御に使用。詳細は`SiteModalContent`のProps定義を参照（#3669） */
  customer?: CustomerEntity | null
  /** 新規作成時の一部項目の初期値。updateRequest 指定時（編集モード）は無視される。 */
  initialValues?: Partial<Pick<CreateSiteDto, 'name' | 'code'>>
  onSuccess: (site: SiteExEntity) => Promise<void>
  onClose: () => void
}

export const SiteModal: FC<Props> = ({
  open,
  tenantKey,
  dcId,
  updateRequest,
  customer,
  initialValues,
  onSuccess,
  onClose
}) => {
  return (
    <Modal
      title={updateRequest ? MENU.EDITING_SITE : MENU.CREATING_SITE}
      zIndex={1999}
      width={860}
      open={open}
      onCancel={onClose}
    >
      <SiteModalContent
        tenantKey={tenantKey}
        dcId={dcId}
        updateRequest={updateRequest}
        customer={customer}
        initialValues={initialValues}
        onSuccess={onSuccess}
        onCancel={onClose}
      />
    </Modal>
  )
}
